
    import {defineComponent, computed} from "vue";

export default defineComponent({
    name: 'checkTitle',
    props: {
        titleCont: {
            type: String,
            default: ''
        },
        count: {
            type: String,
            default: ''
        },
        allCount: {
            type: String,
            default: ''
        },
        hasDefect: {
            type: Boolean,
            default: false
        },
        isExpanded: {
            type: Boolean,
            default: true
        },
    },
    emits: ['toggle'],
    setup(props, { emit }) {
        // 计算状态文本
        const statusText = computed(() => {
            const count = Number(props.count) || 0;
            if (props.hasDefect && count > 0) {
                return `${count}项异常`;
            }
            return '全部正常';
        });

        // 计算箭头图标
        const arrowIcon = computed(() => {
            if (props.isExpanded) {
                return require('@/assets/promiseFrame/arrowUp.png');
            }
            return require('@/assets/promiseFrame/arrowDown.png');
        });

        const handleToggle = () => {
            emit('toggle');
        };

        // 判断是否显示警告图标（只有异常项才显示）
        const showWarningIcon = computed(() => {
            return props.hasDefect && Number(props.count) > 0;
        });

        return {
            statusText,
            arrowIcon,
            handleToggle,
            showWarningIcon
        }
    }
})
